module.exports = __webpack_public_path__ + "img/Do.9aea823c.svg";